import { Col, Form, Row, Space } from "antd";
import { useForm } from "antd/lib/form/Form";
import { IconFilterDown } from "assets";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ROLE } from "common/constant";
import { rulesListService } from "common/constant/rules";
import { SERVICE_YMD_DIV } from "common/constant/service";
import { saveFileWithExactName } from "common/utils/base64Helper";
import { formatFilterDateSlash } from "common/utils/dateHelper";

import { serviceApi } from "services/service";

import { authStore } from "store/slices/auth";
import { setFilterServiceAction } from "store/slices/listData";
import { listFilterStore } from "store/slices/listData";
import { getListServiceOpt, getServiceDriverList, pulldownStore } from "store/slices/pulldown";
import { searchCardStore, setIsServiceCardExpanded } from "store/slices/searchCard";

import "../../order/list/ListOrder.scss";
import TableListService from "../components/TableListService";

import Divider from "components/common/Divider";
import DatepickerFilter from "components/filter/DatepickerFilter";
import InputFilter from "components/filter/InputFilter";
import MultiSelectFilter from "components/filter/MultiSelectFilter";
import RadioCheckFilter from "components/filter/RadioCheckFilter";
import SelectFilter from "components/filter/SelectFilter";

function ListService() {
  const [form] = useForm();
  const dispatch = useDispatch();
  const [listService, setListService] = useState([]);
  const [totalService, setTotalService] = useState();
  const { filterServiceObject } = useSelector(listFilterStore);
  const [page, setPage] = useState(1);
  const [sortParams, setSortParams] = useState([]);
  const [showMoreFilter, setShowMoreFilter] = useState(false);
  const { company_cd, role } = useSelector(authStore);
  const { listOptServiceStatus, listOptOffices, listOptServiceYmd, listOptServiceDriver } =
    useSelector(pulldownStore);
  const { isServiceCardExpanded } = useSelector(searchCardStore);
  const [selectedOffice, setSelectedOffice] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState([]);
  const serviceRequestSeq = useRef(0);
  const serviceCancelSource = useRef(null);

  const service_ymd_div = Form.useWatch("service_ymd_div", form);

  const initialValues = {
    ...filterServiceObject,
    ...(filterServiceObject.service_ymd_start
      ? { service_ymd_start: moment(filterServiceObject.service_ymd_start) }
      : {}),
    ...(filterServiceObject.service_ymd_end
      ? { service_ymd_end: moment(filterServiceObject.service_ymd_end) }
      : {})
  };
  const radioCheckOpt = [
    { label: "すべて", value: null },
    { label: "あり", value: "1" },
    { label: "なし", value: "0" }
  ];

  const checkDate = (service_ymd_div) => {
    switch (service_ymd_div) {
      case SERVICE_YMD_DIV.YESTERDAY:
        form.setFieldValue("service_ymd_start", moment().subtract(1, "days"));
        form.setFieldValue("service_ymd_end", moment().subtract(1, "days"));
        dispatch(
          setFilterServiceAction({
            ...filterServiceObject,
            service_ymd_start: formatFilterDateSlash(moment().subtract(1, "days")),
            service_ymd_end: formatFilterDateSlash(moment().subtract(1, "days")),
            service_ymd_div
          })
        );
        break;
      case SERVICE_YMD_DIV.TODAY:
        form.setFieldValue("service_ymd_start", moment());
        form.setFieldValue("service_ymd_end", moment());
        dispatch(
          setFilterServiceAction({
            ...filterServiceObject,
            service_ymd_start: formatFilterDateSlash(moment()),
            service_ymd_end: formatFilterDateSlash(moment()),
            service_ymd_div
          })
        );
        break;
      case SERVICE_YMD_DIV.TOMORROW:
        form.setFieldValue("service_ymd_start", moment().add(1, "days"));
        form.setFieldValue("service_ymd_end", null);
        dispatch(
          setFilterServiceAction({
            ...filterServiceObject,
            service_ymd_start: formatFilterDateSlash(moment().add(1, "days")),
            service_ymd_end: "",
            service_ymd_div
          })
        );
        break;
      case SERVICE_YMD_DIV.FROM_T0:
        form.setFieldValue("service_ymd_start", null);
        form.setFieldValue("service_ymd_end", null);
        dispatch(
          setFilterServiceAction({
            ...filterServiceObject,
            service_ymd_start: "",
            service_ymd_end: "",
            service_ymd_div
          })
        );
        break;
    }
  };

  const fetchListService = async ({ cancelPrevious = false, requestSeq } = {}) => {
    if (cancelPrevious && serviceCancelSource.current) {
      serviceCancelSource.current.cancel("services request canceled");
    }

    const cancelSource = axios.CancelToken.source();
    serviceCancelSource.current = cancelSource;
    const currentRequestSeq = requestSeq || ++serviceRequestSeq.current;

    const res = await serviceApi.getListService(
      {
        ...filterServiceObject,
        page,
        company_cd,
        sort: sortParams.length > 0 ? sortParams : []
      },
      { cancelToken: cancelSource.token }
    );
    if (currentRequestSeq !== serviceRequestSeq.current) return;
    setListService(res?.items);
    setTotalService(res?.total);
  };

  const handleDownloadSignImage = (service_no) => {
    serviceApi.downloadSignImage(service_no).then((data) => saveFileWithExactName(data));
  };

  const handleDownloadReceiptImage = (service_no) => {
    serviceApi.downloadReceiptImage(service_no).then((data) => saveFileWithExactName(data));
  };

  const handleShowMore = () => {
    setShowMoreFilter(!showMoreFilter);
    dispatch(setIsServiceCardExpanded(!showMoreFilter));
  };

  const handleSortOrders = (pagination, _, sorter) => {
    if (pagination.current === page) {
      if (sorter.length > 1) {
        setSortParams(
          sorter.map((item) => (item.order === "descend" ? `-${item.field}` : item.field))
        );
      } else if (sorter.column) {
        setSortParams([sorter.order === "descend" ? `-${sorter.field}` : sorter.field]);
      } else {
        setSortParams([]);
      }
    }
  };

  const handleFilter = (changedFields) => {
    if (changedFields[0].value) {
      if (["office_cd"].includes(changedFields[0].name[0])) {
        dispatch(
          setFilterServiceAction({
            ...filterServiceObject,
            [changedFields[0].name[0]]: changedFields[0].value
          })
        );
      } else if (["service_ymd_div"].includes(changedFields[0].name[0])) {
        checkDate(changedFields[0].value);
      } else if (["service_ymd_start", "service_ymd_end"].includes(changedFields[0].name[0])) {
        dispatch(
          setFilterServiceAction({
            ...filterServiceObject,
            [changedFields[0].name[0]]: formatFilterDateSlash(changedFields[0].value)
          })
        );
      } else {
        dispatch(
          setFilterServiceAction({
            ...filterServiceObject,
            [changedFields[0].name[0]]: changedFields[0].value
          })
        );
      }
    } else {
      const cloneFilter = { ...filterServiceObject };
      delete cloneFilter[changedFields[0].name[0]];
      dispatch(setFilterServiceAction({ ...cloneFilter }));
    }
    setPage(1);
  };

  const handleChangePage = (currentPage) => {
    setPage(currentPage);
  };

  useEffect(() => {
    if (company_cd) {
      const requestSeq = ++serviceRequestSeq.current;
      const debounceTimer = setTimeout(() => {
        fetchListService({ cancelPrevious: true, requestSeq }).catch((error) => {
          if (axios.isCancel(error)) return;
          return Promise.reject(error);
        });
      }, 500);

      return () => {
        clearTimeout(debounceTimer);
        if (serviceCancelSource.current) {
          serviceCancelSource.current.cancel("services request canceled");
        }
      };
    }
  }, [company_cd, filterServiceObject, sortParams, page]);

  useEffect(() => {
    dispatch(getListServiceOpt());
  }, []);

  useEffect(() => {
    if (selectedOffice?.length > 0) {
      dispatch(getServiceDriverList({ office_cd: selectedOffice[0] }));
    }
  }, [selectedOffice]);

  useEffect(() => {
    if (role && role !== ROLE.ADMIN && listOptOffices.length > 0) {
      setSelectedOffice([listOptOffices[0]?.value]);
      dispatch(
        setFilterServiceAction({
          ...filterServiceObject,
          office_cd: listOptOffices[0]?.value
        })
      );
    }
  }, [listOptOffices, role]);

  // Handle office selection change
  const handleOfficeChange = (values) => {
    setSelectedOffice(values || []);
    setSelectedDriver([]); // Reset driver when office changes
    if (values && values.length > 0) {
      dispatch(
        setFilterServiceAction({
          ...filterServiceObject,
          office_cd: values[0],
          driver_cd: undefined
        })
      );
    } else {
      const cloneFilter = { ...filterServiceObject };
      delete cloneFilter.office_cd;
      delete cloneFilter.driver_cd;
      dispatch(setFilterServiceAction({ ...cloneFilter }));
    }
    setPage(1);
  };

  // Handle driver selection change
  const handleDriverChange = (values) => {
    setSelectedDriver(values || []);
    if (values && values.length > 0) {
      dispatch(
        setFilterServiceAction({
          ...filterServiceObject,
          driver_cd: values[0]
        })
      );
    } else {
      const cloneFilter = { ...filterServiceObject };
      delete cloneFilter.driver_cd;
      dispatch(setFilterServiceAction({ ...cloneFilter }));
    }
    setPage(1);
  };



  useEffect(() => {
    if (listOptServiceYmd.length > 0 && !filterServiceObject.service_ymd_div) {
      form.setFieldValue("service_ymd_div", SERVICE_YMD_DIV.TODAY);
      dispatch(
        setFilterServiceAction({
          ...filterServiceObject,
          service_ymd_div: SERVICE_YMD_DIV.TODAY
        })
      );
    }
  }, [listOptServiceYmd]);

  useEffect(() => {
    if (isServiceCardExpanded)
      setShowMoreFilter(true);
  }, []);

  return (
    <div className="list-order-page bg-white">
      <Row className="header-order" align="middle" justify="space-between">
        <h1 className="fs-24 fw-700">運行一覧</h1>
      </Row>
      <Divider height="2px" />
      <Form
        autoComplete="off"
        onFieldsChange={handleFilter}
        form={form}
        initialValues={initialValues}
      >
        <Row>
          <Col span={21}>
            <Row className="filter-group" gutter={[16, 12]}>
              <SelectFilter
                title="運行日区分"
                name="service_ymd_div"
                placeholder="お選びください"
                listOptions={listOptServiceYmd}
                width={160}
                allowClear={false}
              />
              <DatepickerFilter
                title="運行日開始・終了"
                placeholder="yy年m月d日(曜日)"
                name="name"
                preName="service_ymd_start"
                sufName="service_ymd_end"
                disabled={service_ymd_div !== SERVICE_YMD_DIV.FROM_T0}
              />
              <RadioCheckFilter
                title="受領書"
                name="receip_flag"
                options={radioCheckOpt}
                defaultValue={null}
              />
              <RadioCheckFilter
                title="電子サイン"
                name="sign_flag"
                options={radioCheckOpt}
                defaultValue={null}
              />
            </Row>
          </Col>
          <Col span={3}>
            <Space
              className={`show-more-filter ${showMoreFilter && "rotate"}`}
              onClick={handleShowMore}
            >
              <div className="font-bold">
                {showMoreFilter ? "詳細条件を閉じる" : "詳細条件をすべて表示"}
              </div>
              <IconFilterDown />
            </Space>
          </Col>
        </Row>
        {showMoreFilter ? (
          <>
            <Row className="filter-group" gutter={[16, 12]}>
              <RadioCheckFilter
                title="メモ"
                name="memo_flag"
                options={radioCheckOpt}
                defaultValue={null}
              />
              <SelectFilter
                title="ステータス"
                name="service_status"
                placeholder="お選びください"
                listOptions={listOptServiceStatus}
                width={260}
              />
              <MultiSelectFilter
                title="営業所"
                placeholder="お選びください"
                listOptions={listOptOffices}
                value={selectedOffice}
                onChange={handleOfficeChange}
                width={260}
                dropdownWidth={300}
                showActions={false}
                multiple={false}
                disabled={role !== ROLE.ADMIN}
              />
              <MultiSelectFilter
                title="ドライバー"
                placeholder="お選びください"
                listOptions={listOptServiceDriver}
                value={selectedDriver}
                onChange={handleDriverChange}
                width={260}
                dropdownWidth={300}
                showActions={false}
                multiple={false}
              />
            </Row>
            <Row className="filter-group" gutter={[16, 12]}>
              <InputFilter
                title="集荷先名"
                placeholder=""
                name="pickup_addr_nm"
                width={250}
                rules={rulesListService.max_length_30}
              />
              <InputFilter
                title="荷受人名"
                placeholder=""
                name="consignee_nm"
                width={260}
                rules={rulesListService.max_length_30}
              />
            </Row>
          </>
        ) : (
          <Row className="filter-group" gutter={[16, 12]}>
            <RadioCheckFilter
              title="メモ"
              name="memo_flag"
              options={radioCheckOpt}
              defaultValue={null}
            />
            <MultiSelectFilter
              title="営業所"
              placeholder="お選びください"
              listOptions={listOptOffices}
              value={selectedOffice}
              onChange={handleOfficeChange}
              width={260}
              dropdownWidth={300}
              showActions={false}
              multiple={false}
              disabled={role !== ROLE.ADMIN}
            />
            <MultiSelectFilter
              title="ドライバー"
              placeholder="お選びください"
              listOptions={listOptServiceDriver}
              value={selectedDriver}
              onChange={handleDriverChange}
              width={260}
              dropdownWidth={300}
              showActions={false}
              multiple={false}
            />
            <InputFilter
              title="集荷先名"
              placeholder=""
              name="pickup_addr_nm"
              width={250}
              rules={rulesListService.max_length_30}
            />
          </Row>
        )}
      </Form>
      <TableListService
        page={page}
        dataSource={listService}
        totalRow={totalService}
        onSortOrders={handleSortOrders}
        onPageChange={handleChangePage}
        handleDownloadSignImage={handleDownloadSignImage}
        handleDownloadReceiptImage={handleDownloadReceiptImage}
      />
    </div>
  );
}

export default ListService;
